import Typography from "@mui/material/Typography";

const RecipientTooltipTitle = () => (
    <Typography
        variant='subtitle2'
        sx={{
            fontSize: 12
        }}
    >
        A Recipient Account needs to be linked to the bank in order to enable it
    </Typography>
);

export default RecipientTooltipTitle;
